// Added by Jonghyung Lee on 2020-05-08
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export interface ClientInfo {
  id: string
  ip: string
  nickname: string
}

export enum ErrType {
  UvncNoPermission = 'UvncNoPermission',
  UvncNotInstalled = 'UvncNotInstalled',
  UvncInexecutable = 'UvncInexecutable',
  UnsupportedUvncVersion = 'UnsupportedUvncVersion',
  UvncInvalidCall = 'UvncInvalidCall',
  UvncAlreadyStarted = 'UvncAlreadyStarted',
  ServerError = 'ServerError'
}

// # received client info
export enum ReceivedClientInfoEvent {
  Connect = 'Connect',
  Disconnect = 'Disconnect'
}

// socket.io의 메시지와 양식을 맞춤.
export enum RelayEvent{
  //send
  UserKick = 'user-kick',
  ControlGive = 'give-control',
  ControlStop = 'stop-control',
  MouseEvent = 'mouse-event',
  
  //receive
  ChangeRemoteClient = 'change-remote-client',
}